const PageNotFound = () => {
    return(
        <div className="w-screen h-screen grid items-center justify-center text-4xl font-semibold">
            404 Page not found
        </div>
    )
}

export default PageNotFound